import React, { useCallback, useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { Navbar, SideBar } from "./Layouts/MainPage";
import { SidebarItem } from "./Layouts/MainPage/SideBar";
import { useTranslation } from "react-i18next";
import Dashboard from "./Components/Icons/Dasboard";
import Task from "./Components/Icons/Task";
import Maintanance from "./Components/Icons/Maintanance";
import Products from "./Components/Icons/Products";
import Marketing from "./Components/Icons/Marketing";
import Procurement from "./Components/Icons/Procurement";
import Team from "./Components/Icons/Team";
import Report from "./Components/Icons/Report";
import Chat from "./Components/Icons/Chat";
import Payments from "./Components/Icons/Payments";
import Sales from "./Components/Icons/Sales";
// import Store from "./Components/Icons/Store";
import Shipping from "./Components/Icons/Shipping";
import { GetAccess, GetDashboardRole, GetMultipleAccess, GetRole } from "./Components/Utils/roles";
import {
  LayoutDashboard,
  Gavel,
  FolderKanban,
  NotebookPen,
  CalendarCheck,
  Truck,
  ClipboardCheck,
  Store,
  Users,
  BookUser,
  BarChart2
} from "lucide-react"
import DashboardSide from "./Components/Icons/DasboardSide";
import Items from "./Components/Icons/Items";
import Bidding from "./Components/Icons/Bidding";
import Project from "./Components/Icons/Project";
import Notes from "./Components/Icons/Notes";
import Members from "./Components/Icons/Member";
import Contacts from "./Components/Icons/Contacts";
import Timesheet from "./Components/Icons/TimeSheet";

const App = () => {
  const {t} = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const {officeId} = useParams();


    // handle what happens on key press
    const handleKeyPress = useCallback((event) => {
      if(event.key === "Escape") {
        navigate(-1);
      }
    }, []);
  
    useEffect(() => {
      // attach the event listener
      document.addEventListener('keydown', handleKeyPress);
  
      // remove the event listener
      return () => {
        document.removeEventListener('keydown', handleKeyPress);
      };
    }, [handleKeyPress]);


  function isActiveFun(x){
    let actualPath = location.pathname.split("/")[3]
    console.log("path",actualPath);
    
    let linkPath = ""
    if(x?.hasSubMenu){
      if(x?.subMenu){
         let y = x.subMenu[0].link;
         let z = y.split("/")[0]
         linkPath = z
      }
    }else{
      linkPath = x?.link;
    }
    console.log("link path",linkPath.includes(actualPath));
    
    if(linkPath.includes(actualPath)) {
      return true;
    }else{
      return false;
    }
  }




const navItem = [
  {
    icon: <LayoutDashboard size={18} />,
    title: "Dashboard",
    hasSubMenu: false,
    hasAccess: true,
    link: GetDashboardRole("") ? "dashboard" :
      GetDashboardRole("sales") ? `/main/${officeId}/dashboard/sales` :
      GetDashboardRole("procurement") ? `/main/${officeId}/dashboard/procurement` :
      GetDashboardRole("store") ? `/main/${officeId}/dashboard/stores` :
      `/main/${officeId}/dashboard`,
  },

  {
    icon: <Gavel size={18} />,
    title: "Bidding",
    link: GetAccess("bids_view") ? `/main/${officeId}/bidding/bids` :
      GetAccess("estimation_view") ? `/main/${officeId}/bidding/estimation` :
      GetAccess("activity_item_view") ? `/main/${officeId}/bidding/activity` :
      GetAccess("terms_and_condition_view") ? `/main/${officeId}/bidding/teamandcondition` : "#",
       hasAccess: ["bids_view", "estimation_view", "activity_item_view", "terms_and_condition_view"],
   hasSubMenu: false,
    subMenu: [],
  },

  {
    icon: <FolderKanban size={18} />,
    title: "Projects",
    link: GetAccess("project_view") ? `/main/${officeId}/projects` : "#",
      hasAccess: ["project_view"],
    hasSubMenu: false,
  },

  {
    icon: <NotebookPen size={18} />,
    title: "My Diary",
    link: GetAccess("my_diary_view") ? `/main/${officeId}/mainNotes` : "#",
       hasAccess: ["my_diary_view"],
    hasSubMenu: false,
    subMenu: [],
  },

  {
    icon: <CalendarCheck size={18} />,
    title: "HR",
    link: GetAccess("attendance_view") ? `/main/${officeId}/hr/attendance` :
      GetAccess("timesheets_view") ? `/main/${officeId}/hr/timesheets` :
      GetAccess("team_view") ? `/main/${officeId}/hr/team` : "#",
    hasAccess: ["attendance_view", "timesheets_view", "team_view"],
    hasSubMenu: false,
    subMenu: [],
  },

  {
    icon: <Truck size={18} />,
    title: "Procurement",
    link: GetAccess("product_view") ? `/main/${officeId}/procurement/items` :
      GetAccess("purchase_request_view") ? `/main/${officeId}/procurement/purchase-requests` :
      GetAccess("suppliers_view") ? `/main/${officeId}/procurement/product-comparison` :
      GetAccess("rfq_view") ? `/main/${officeId}/procurement/rfq` :
      GetAccess("purchase_order_view") ? `/main/${officeId}/procurement/purchase-order` :
      GetAccess("payment_request_view") ? `/main/${officeId}/procurement/payment-request` : "#",
    hasAccess: ["purchase_request_view", "rfq_view", "supplier_quote_view", "quote_compare_view", "purchase_order_view", "suppliers_view"],
    hasSubMenu: false,
    subMenu: [],
  },

  {
    icon: <ClipboardCheck size={18} />,
    title: "Invoices",
    link: GetAccess("invoice_in_view") ? `/main/${officeId}/sales/invoice_incoming` :
      GetAccess("invoice_out_view") ? `/main/${officeId}/sales/invoice_outgoing` : "#",
    hasAccess: ["invoice_in_view", "invoice_out_view"],
    hasSubMenu: false,
    subMenu: [],
  },

  {
    icon: <Store size={18} />,
    title: "Store",
    link: GetAccess("shipment_tracking_view") ? `/main/${officeId}/store/shipment-tracking` :
      GetAccess("grn_view") ? `/main/${officeId}/store/grn` :
      GetAccess("inventory_view") ? `/main/${officeId}/store/inventory` :
      GetAccess("assets_view") ? `/main/${officeId}/store/assets` :
      GetAccess("delivery_notes_view") ? `/main/${officeId}/store/delivery-note` :
      GetAccess("returns_view") ? `/main/${officeId}/store/returns` :
      GetAccess("requests_view") ? `/main/${officeId}/store/requests` : "#",
    hasAccess: ["shipment_tracking_view", "grn_view", "inventory_view", "assets_view", "delivery_notes_view", "packing_list_view", "returns_view", "requests_view"],
    hasSubMenu: false,
    subMenu: [],
  },

  {
    icon: <Users size={18} />,
    title: "Employees",
    link: GetAccess("employees_view") ? `/main/${officeId}/employees` : "#",
    access: GetAccess("contacts_module"),
    hasSubMenu: false,
    subMenu: [],
  },

  {
    icon: <BookUser size={18} />,
    title: "Contacts",
    link: GetAccess("customers_view") ? `/main/${officeId}/contacts/customers` :
      GetAccess("sub_contractor_view") ? `/main/${officeId}/contacts/sub-con` :
      GetAccess("vendor_view") ? `/main/${officeId}/contacts/suppliers` :
      GetAccess("rental_manpower_view") ? `/main/${officeId}/contacts/rental-man` :
      GetAccess("agents_view") ? `/main/${officeId}/contacts/agents` : "#",
    hasAccess: ["contacts_module", "rental_manpower_view", "vendor_view", "customers_view", "sub_contractor_view", "agents_view"],
    hasSubMenu: false,
    subMenu: [],
  },

  {
    icon: <BarChart2 size={18} />,
    title: "Report",
    link: `/main/${officeId}/reports`,
    hasAccess: ["report_view"],
    hasSubMenu: false,
  },
];


  return (
    <div className=" w-full h-screen bg-slate-100 flex justify-start items-center overflow-hidden">
      <div className=" hidden w-16 z-[997] lg:block">
      <SideBar>
        {navItem && 
          navItem.map((item,idx) => {
            
            return (
              <>
              {
                (item?.hasAccess == true||GetMultipleAccess(item?.hasAccess||[]) )&&(<SidebarItem
                    icon={item?.icon}
                    text={t(item?.title)}
                    hasSubMenu={item?.hasSubMenu}
                    subItem={item?.subMenu}
                    link={item?.link}
                    active={isActiveFun(item)}
                    key={idx}
                  />
                )
              }
              </>
            );
          })}
      </SideBar>
      </div>
      <div className=" w-full h-[100vh]  ">
        <div className=" w-full h-[59px] bg-white z-50 shadow-lg">
          <Navbar />
        </div>
        <div className=" w-full h-[calc(100vh-87px)]  overflow-y-auto">
          <Outlet />
        </div>
        {/* <div className=" w-full h-7 ">
          <p className=' font-semibold text-center text-s text-slate-400'>
            <a
             href="https://numota.in"
             target="_blank"
            >
              &#169;  numota
            </a>
            </p>
        </div> */}
      </div>
    </div>
  );
};

export default App;
